export default function Logo({ size = 48, invert = false, showText = true, animate = false, className = "" }) {
  return (
    <div className={`flex items-center gap-3 ${className}`} data-testid="hbt-logo">
      <span className={animate ? "logo-anim" : "inline-flex"}>
        <img
          src="/logo/hbt-mark.svg"
          alt="HBT"
          width={size}
          height={size}
          style={{
            width: size,
            height: size,
            display: "block",
            objectFit: "contain",
            filter: invert ? "brightness(0) invert(1)" : "none",
          }}
        />
      </span>
      {showText && (
        <div className="leading-tight">
          <div
            className="font-display font-bold tracking-tight text-[19px]"
            style={{ color: invert ? "var(--bone)" : "inherit" }}
          >
            HBT Waste
          </div>
          <div
            className="font-display text-[12px] font-semibold tracking-[0.18em] uppercase mt-0.5"
            style={{ color: invert ? "rgba(245,242,234,0.7)" : "var(--muted, #4A4D4A)" }}
          >
            Management
          </div>
        </div>
      )}
    </div>
  );
}
